import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { membersData } from '../../mockData/members';
import './index.css';
import './index.mobile.css';

export default function MemberDetail() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const members = membersData[i18n.language] ?? membersData['zh'];
  const member = members.find((m) => String(m.id) === id);

  if (!member) {
    return (
      <div className="md-page">
        <div className="md-not-found">{t('member.notFound')}</div>
      </div>
    );
  }

  return (
    <div className="md-page">
      <div className="md-bg-deco" />
      <div className="md-container">
        <div className="md-card">
          <div
            className="md-avatar-deco"
            style={{ backgroundImage: `url(/image/ff-promo/Group_176.png)` }}
          />
          <div className="md-avatar-section">
            <div className="md-avatar-wrap">
              <img src={member.image} alt={member.name} className="md-avatar" loading="lazy" />
            </div>
          </div>

          <h1 className="md-name">{member.name}</h1>

          <p className="md-titles">{member.titles.join('、')}</p>

          <span className="md-role-tag">{member.role}</span>

          <p className="md-bio">{member.bio}</p>
        </div>
      </div>
    </div>
  );
}
